import { Injectable } from '@angular/core';

import {httpOptions} from '../../configurations/configuration';
import { HttpClient, HttpHeaders,HttpErrorResponse} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SponsorService {

  
  constructor(private http: HttpClient) { }

  updateSponsor(postObj:any) : Observable<any> {
      return this.http.post(environment.apiURL + environment.adminApiUrl + environment.updateSponsorUrl, postObj,httpOptions);
  }
        
  insertSponsor(postObj:any) : Observable<any> {
      return this.http.post(environment.apiURL + environment.adminApiUrl + environment.insertSponsorUrl, postObj,httpOptions);
  }    
  
  getSponsor( id: any) : Observable<any> {
      
      if(id){

      }
      else {
          id = 1;
      }

      return this.http.get(environment.apiURL + environment.adminApiUrl + environment.getSponsorUrl+"/" + id);
  }

  getAllSponsor(filterObj,start,limit){

    // filterObj.languageId = localStorage.getItem('languageId');
    filterObj.languageId = undefined;

      let urlGetAllSponsor = environment.apiURL + environment.adminApiUrl + environment.getSponsorUrl +'?filter='+encodeURIComponent(JSON.stringify(filterObj))+'&start='+start+'&limit='+limit;
      return this.http.get<any>(urlGetAllSponsor)
  }

  deleteSponsor(postObj:any) : Observable<any> {
      return this.http.post(environment.apiURL + environment.adminApiUrl + environment.deleteSponsorUrl, postObj,httpOptions);
  }
}
